import { defineStore } from 'pinia';
import { ShippingCompany } from '../entities/shipping-company';

export const useShippingCompaniesDialogStore = defineStore('shippingCompaniesDialog', {
	state: () => ({
		isOpen: false,
		loading: false,
		companies: [],
		selectedCompanyId: '',
		step: 1,
		editCompanyData: null,
        editCompanyId: null
	}),
	getters: {
		company(state) {
			return state.companies.find((c) => c.id === state.selectedCompanyId);
		},
	},
	actions: {
		async fetchCompanies() {
			this.loading = true;
			try {
				const data = await ShippingCompany.getAllShippingCompanies({
                    for_custom_link: 1
                });
				this.companies = data;
			} finally {
				this.loading = false;
			}
		},
		openDialog() {
			this.isOpen = true;
		},
		resetData() {
			this.isOpen = false;
			this.loading = false;
			this.selectedCompanyId = '';
			this.step = 1;
			this.companies = [];
			this.editCompanyData = null;
			this.editCompanyId = null;
		},
	},
});
